<template>
  <v-dialog v-model="internalValue" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>{{ message }}</v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelar">Cancelar</v-btn>
        <v-btn color="red" dark @click="confirmar">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: Boolean,
    title: {
      type: String,
      default: 'Confirmação',
    },
    message: {
      type: String,
      default: 'Tem certeza que deseja continuar?',
    },
  },
  data() {
    return {
      internalValue: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = val;
      },
    },
    internalValue(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    cancelar() {
      this.$emit('input', false);
    },
    confirmar() {
      this.$emit('confirm');
      this.$emit('input', false);
    },
  },
};
</script>
